export const CREATE_COUPON_ACTION = '[Coupon Action] Create Coupon';
export const CONFIRMED_CREATE_COUPON_ACTION = '[Coupon Action] Confirmed Create Coupon';
export const CREATE_COUPON_ERROR_ACTION='[Coupon Action] Create Coupon Error';
export const GET_COUPONS = '[Coupon Action] Get Coupons';
export const CONFIRMED_GET_COUPONS = '[Coupon Action] Confirmed Get Coupons';
export const LOADING_COUPONS = '[Coupon Action] Loading for Coupons';
export const EDIT_COUPON_ACTION = '[Coupon Action] Edit Coupon';
export const CONFIRMED_EDIT_COUPON_ACTION = '[Coupon Action] Confirmed Edit Coupon';
export const DELETE_COUPON_ACTION = '[Coupon Action] Delete Coupon';
export const CONFIRMED_DELETE_COUPON_ACTION = '[Coupon Action] Confirmed Delete Coupon';
export const COUPON_ERROR_ACTION = '[Coupon Action] Error';
export const CLEAR_COUPON_ERROR = '[Coupon Action] Clear Error';



